import { Password, PasswordProps } from "primereact/password";
import { useMemo } from "react";
import * as Yup from "yup";
import {
  Field,
  FastField,
  FormikContextType,
  FieldInputProps,
  FieldMetaProps,
} from "formik";
import { FormInputLabel } from "./FormInputLabel";
import { ErrorMessage } from "formik";
import ErrorWithIconText from "./ErrorWithIconText";
import TextError from "./TextError";
import { classNames } from "primereact/utils";

export interface FormikInputPasswordProps extends PasswordProps {
  label: string;
  name: string;
  isIndependent?: boolean;
  validationSchema?: Yup.ObjectSchema<any, Yup.AnyObject, any, "">;
  withIcon?: boolean;
}

function FormikInputPassword({
  label,
  name,
  isIndependent = false,
  validationSchema,
  withIcon = false,
  ...rest
}: FormikInputPasswordProps) {
  const Component = useMemo(
    () => (isIndependent ? FastField : Field),
    [isIndependent]
  );

  return (
    <>
      <FormInputLabel
        nameFor={name}
        validationSchema={validationSchema}
        forceIsRequired={rest.required}
      >
        {label}
      </FormInputLabel>
      <Component name={name}>
        {({
          form,
          field,
          meta,
        }: {
          form: FormikContextType<any>;
          field: FieldInputProps<string>;
          meta: FieldMetaProps<string>;
        }) => {
          return (
            <Password
              id={name}
              className={classNames({
                "w-full": true,
                "p-invalid": meta.error && meta.touched,
              })}
              inputClassName="w-full"
              placeholder={label}
              value={field.value}
              onBlur={(e) => form.setFieldTouched(name)}
              onChange={(e) => {
                form.setFieldValue(name, e.target.value);
              }}
              {...rest}
            />
          );
        }}
      </Component>
      <ErrorMessage
        component={withIcon ? ErrorWithIconText : TextError}
        name={name}
      />
    </>
  );
}

export default FormikInputPassword;
